import { AxiosError } from 'axios';
import { t } from 'i18next';

import { renderErrorMessage } from './errorMessages';
import { ErrorCase } from './types';

interface ErrorResponseData {
  statusCode?: number;
  code?: string;
  data?: Record<string, unknown>;
}

const CASE = {
  NOT_AUTHORIZE: 'NOT_AUTHORIZE',
  GO_HOME: 'GO_HOME',
  GO_UPPER: 'GO_UPPER',
  ERROR_TOAST: 'ERROR_TOAST',
  PASS: 'PASS',
  GO_BEFORE: 'GO_BEFORE',
};

const ERROR_ACTIONS: ErrorCase = {
  400: {},
  401: {},
  403: {
    NOT_PUBLISHED_CHAPTER: CASE.NOT_AUTHORIZE,
    NOT_OWNER_USER: CASE.ERROR_TOAST,
    EXPIRED_PURCHASED_CHAPTER: CASE.ERROR_TOAST,
    TITLE_STATUS_DRAFT: CASE.GO_BEFORE,
  },
  404: {},
  409: {},
};

const controlError = (error: AxiosError<ErrorResponseData>) => {
  const statusCode = error.response?.data?.statusCode;
  const errorCode = error.response?.data?.code;
  const errorCase = ERROR_ACTIONS?.[statusCode ?? 0]?.[errorCode ?? ''] ?? CASE.PASS;

  const handleFn = {
    [CASE.NOT_AUTHORIZE]() {
      throw error;
    },
    [CASE.GO_HOME]() {
      window.location.assign('/');
    },
    [CASE.GO_BEFORE]() {
      window.history.back();
    },
    [CASE.PASS]: () => {
      return true;
    },
    [CASE.ERROR_TOAST]: () => {
      handleFailToast(t(renderErrorMessage(error)));
    },
  };

  return handleFn?.[errorCase];
};

const handleFailToast = (message: string) => {
  // Add your toast logic here
  console.error(`Toast Error: ${message}`);
};

const handleErrorExcept403 = (error: AxiosError<ErrorResponseData>) => {
  const unregisteredUser = error.response?.status === 403;
  const data = error.response?.data;
  // 블럭 유저
  const blockedUser =
    (unregisteredUser && data?.code === 'BLOCKED') || (unregisteredUser && data?.code === 'BLOCKED_COMMUNITY');

  if (blockedUser) {
    handleErrorBlockedUser(error);
    return;
  }

  controlError(error) ? controlError(error)() : handleFailToast(t(renderErrorMessage(error)));

  if (!unregisteredUser) {
    // handleErrorToastMsg(error);
  }
};

const handleErrorBlockedUser = (error: AxiosError<ErrorResponseData>) => {
  // showModal({
  //   body: (
  //     <BlockedUserModalBody
  //       isCommunityBlocked={code === 'BLOCKED_COMMUNITY'}
  //       userName={blockedUserData.userName}
  //       writername={blockedUserData.writername}
  //       comment={blockedUserData.comment}
  //       endAt={blockedUserData.endAt}
  //     />
  //   ),
  //   modalWrapStyle: {
  //     'max-width': 'fit-content',
  //     padding: '0',
  //     borderRadius: '12px',
  //     maxHeight: '80vh',
  //   },
  //   closeOnBackdropClick: false,
  // });
};

export { handleFailToast, handleErrorExcept403 };
